import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { RolePermission } from 'src/app/services';
import { SelectionOptionsPopUpService } from 'src/app/selection-options-pop-up.service';
import { ConfirmationPopUpService } from 'src/app/services/confirmation-pop-up.service';
import { SettingsPopUpService } from 'src/app/settings-pop-up.service';
import { PageOptionsPopUpService } from 'src/app/widgets/page-options-pop-up-button/page-options-pop-up.service';
import { LoginLogoutService } from 'src/app/services/login.service';
import { FiltersGroupsSettingsPopUpService } from 'src/app/widgets/filters/services/filters-groups-settings-pop-up.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';

@Component({
    selector: 'app-common-page-layout',
    templateUrl: './common-page-layout.component.html',
    styleUrls: ['./common-page-layout.component.scss'],
    standalone: false
})
export class CommonPageLayoutComponent implements OnInit {

	@Output()
	public onContainerClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

	private generateSubMenuItems(menuItem: any, permissions: RolePermission[], newMenuItem: any) {
		if (menuItem.items) {
			menuItem.items.forEach(
				item => {
					let subMenuItem = this.getMenuItemIfVisible(item, permissions);

					if (!subMenuItem) {
						return;
					}

					subMenuItem.parentMenuId = menuItem.menuId;

					let newSubMenuItem = {...subMenuItem};

					if (subMenuItem.items) {
						newSubMenuItem.items = [];
					}

					this.generateSubMenuItems(subMenuItem, permissions, newSubMenuItem);

					newMenuItem.items.push(newSubMenuItem);
				}
			);
		}
	}

	private getMenuItemIfVisible(navigation: any, permissions: RolePermission[]): any {
		let menuPermission = permissions.filter(permission => permission.menuId === navigation.menuId);

		if (menuPermission.length < 1 || !menuPermission[0].isVisible) {
			return null;
		}
		return navigation;
	}

	@ViewChild('container') containerRef!: ElementRef;

	get containerHeight(): string {
		return this.containerRef?.nativeElement?.scrollHeight + 'px' || '100%';
	}

	get containerWidth(): string {
		return this.containerRef?.nativeElement?.scrollWidth + 'px' || '100%';
	}

	constructor(
		public loginLogService: LoginLogoutService,
		public confirmationPopUpService: ConfirmationPopUpService,
		public settingsPopUpService: SettingsPopUpService,
		public selectionOptionsPopUpService: SelectionOptionsPopUpService,
		public pageOptionsPopUpService: PageOptionsPopUpService,
		public filtersGroupsSettingsPopUpService: FiltersGroupsSettingsPopUpService,
		public loadingIndicationService: LoadingIndicationService,
	) { }

	ngOnInit() {}
}
